import React from "react";

function PageNotFound() {
    return (
        <div className="error-page">
            <p className="error-page__bg">
                <svg
                    width="299"
                    height="169"
                    viewBox="0 0 299 169"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M77.5145 128.51V166H58.8845V128.51H0.234453V109.88L51.0645 3.16H77.5145V111.03H96.8345V128.51H77.5145ZM59.3445 23.17H58.8845L19.0945 111.03H59.3445V23.17ZM196.181 84.58C196.181 90.8667 195.875 97.3067 195.261 103.9C194.801 110.493 193.881 116.933 192.501 123.22C191.275 129.507 189.511 135.41 187.211 140.93C185.065 146.45 182.228 151.28 178.701 155.42C175.328 159.56 171.265 162.857 166.511 165.31C161.758 167.763 156.238 168.99 149.951 168.99C143.665 168.99 138.145 167.763 133.391 165.31C128.638 162.857 124.498 159.56 120.971 155.42C117.598 151.28 114.761 146.45 112.461 140.93C110.315 135.41 108.551 129.507 107.171 123.22C105.945 116.933 105.025 110.493 104.411 103.9C103.951 97.3067 103.721 90.8667 103.721 84.58C103.721 75.2267 104.335 65.5667 105.561 55.6C106.788 45.48 109.088 36.3567 112.461 28.23C115.988 20.1033 120.741 13.4333 126.721 8.21999C132.701 2.85333 140.445 0.169996 149.951 0.169996C159.458 0.169996 167.201 2.85333 173.181 8.21999C179.161 13.4333 183.838 20.1033 187.211 28.23C190.738 36.3567 193.115 45.48 194.341 55.6C195.568 65.5667 196.181 75.2267 196.181 84.58ZM175.021 84.58C175.021 78.9067 174.715 72.3133 174.101 64.8C173.641 57.1333 172.568 49.9267 170.881 43.18C169.195 36.28 166.665 30.4533 163.291 25.7C160.071 20.9467 155.625 18.57 149.951 18.57C144.278 18.57 139.755 20.9467 136.381 25.7C133.161 30.4533 130.631 36.28 128.791 43.18C127.105 49.9267 126.031 57.1333 125.571 64.8C125.111 72.3133 124.881 78.9067 124.881 84.58C124.881 88.4133 124.958 92.7067 125.111 97.46C125.418 102.213 125.801 107.043 126.261 111.95C126.875 116.857 127.718 121.61 128.791 126.21C130.018 130.81 131.551 134.95 133.391 138.63C135.231 142.157 137.455 145.07 140.061 147.37C142.821 149.517 146.118 150.59 149.951 150.59C153.631 150.59 156.851 149.517 159.611 147.37C162.371 145.07 164.671 142.157 166.511 138.63C168.351 134.95 169.808 130.81 170.881 126.21C172.108 121.61 172.951 116.857 173.411 111.95C174.025 107.043 174.408 102.213 174.561 97.46C174.868 92.7067 175.021 88.4133 175.021 84.58ZM279.429 128.51V166H260.799V128.51H202.149V109.88L252.979 3.16H279.429V111.03H298.749V128.51H279.429ZM261.259 23.17H260.799L221.009 111.03H261.259V23.17Z"
                        fill="#F3F6FA"
                    />
                </svg>
            </p>
            <div className="error-page__inner">
                <svg
                    width="51"
                    height="40"
                    viewBox="0 0 51 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="error-page__icon"
                >
                    <path
                        d="M2 2L11.9792 11.8698"
                        stroke="#5080C6"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M11.9792 2L1.99999 11.8698"
                        stroke="#5080C6"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M39 2L48.9792 11.8698"
                        stroke="#3B70BE"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M48.9792 2L39 11.8698"
                        stroke="#3B70BE"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.96875 28H44.4844"
                        stroke="#5080C6"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M32.5 33.5V28.0537H42.5V33.5C42.5 36.2614 40.2614 38.5 37.5 38.5C34.7386 38.5 32.5 36.2614 32.5 33.5Z"
                        stroke="#5080C6"
                        strokeWidth="3"
                    />
                </svg>
                <h4 className="error-page__title">ページが見つかりません</h4>
                <p className="error-page__desc">
                    これはあなたが探しているページではないようです
        </p>
            </div>
        </div>
    );
}
export default PageNotFound;
